import { Link } from "react-router-dom";

type Props = {
    title: string;
    content: string;
    target?: string;
}

export const HelpCenterCard = ({ title, content, target }: Props) => {

    return (
        <Link to={target}>
            <div className="help-center-card">
                <span className="help-center-card-title">
                    { title }
                </span>

                <p>
                    { content }
                </p>
            </div>
        </Link>
    )
}